<form [formGroup]="form">
  <div class="row mb-3">
    <div class="col-sm-3">{{title}}</div>
    <div class="col-sm-6">
      <div class="col-auto">
        <div class="table-responsive w-100 mb-3">
          <table class="table">
            <thead>
              <tr>
                <th class="text-center">ลำดับ</th>
                <th class="text-center">ชื่อไฟล์</th>
                <th class="text-center">download</th>
              </tr>
            </thead>
            <tbody [formArrayName]="formArrayName">
              <tr *ngFor="let attachment of  ( record$ | async)?.controls; index as i">
                <td class="text-center align-middle">{{i+1}}</td>
                <td class="text-center align-middle">
                  {{ attachment.get("originalFileName")?.value }}
                </td>
                <td class="text-center align-middle">
                  <a class="btn btn-icon btn-light  btn-sm  cursor-pointer"
                     (click)="onDownloadFile(attachment.get('generateFileName')?.value, attachment.get('fileExtension')?.value, attachment.get('originalFileName')?.value)">
                    <i class="fas fa-download" style="color:  #6571ff;"></i>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="row" [hidden]="isDisabled">
          <div class="col-12">
            <div class="d-grid gap-2 d-md-flex justify-content-md-end">
              <label class="btn btn-outline-primary">
                เพิ่มเอกสารแนบ <input type="file" style="display: none;"
                                      (change)="onFileChange($event)">
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
